import CreateNewFolderIcon from "@mui/icons-material/CreateNewFolder";
import * as React from "react";
import { useContext, useState } from "react";
import { Context } from "../../../../Context/context";
import { baseStyle } from "../../../../theme";
import { ImageUpload } from "./ImageUpload";
import { ArtThreadGallerySelect } from "./ArtThreadGallerySelect";
import { THREE_INST } from "../../../SketchUtilities/Three/threeSingleton";
import { Button } from "@mui/material";
import ShapeGallery from "./ShapeGallery"
import { useAuth } from '../../../../Context/AuthContext'

interface Props {
  isMobile?: boolean;
}

const ShapeContainer = (props: Props) => {
  const auth = useAuth();
  const three = THREE_INST.getInst();
  const { isMobile } = props;
  const {
    state: {
      imageModalOpen
    },
    dispatch,
  } = useContext(Context);
  const [galleryOpen, setGalleryOpen] = useState<boolean>(false);
  const baseTheme = baseStyle({ containerWidth: "50%", menuWidth: "30%" });

  /* eslint react-hooks/exhaustive-deps: off */
  React.useEffect(() => {
    three.obj.isImageMenuOpen = imageModalOpen;
  }, [imageModalOpen]);




  const secondaryUI = {
    padding: "10px",
    fontFamily: "'amatic', cursive",
  } as React.CSSProperties;

  const loadButton = () => {
    return (
      <Button
        variant="contained"
        onClick={() => {
          if (!imageModalOpen) {
            dispatch({
              type: "close_imagemodal",
              value: true,
            });
          }
        }}
        color="primary"
      >
        <CreateNewFolderIcon />
        <p>Load An Image!</p>
        <ImageUpload />
      </Button>
    );
  };


  return (
    <div style={{ display: "flex", zIndex: 1001 }} id={"shapes"}>
      <div className={isMobile ? baseTheme.mobileMenu : ""}>
        <ShapeGallery/>
        <div id={"shapeButton"} style={secondaryUI}>
          {( auth.state.isLoggedIn ) && 
              <Button
                variant="contained"
                onClick={() => {
                  setGalleryOpen(true);
                }}
                color="primary"
              >
                Get Images from your Gallery
              </Button>
          }
          { loadButton() }

          {ArtThreadGallerySelect({
            open: galleryOpen,
            close: () => {
              setGalleryOpen(false);
            },
          })}

        </div>
      </div>
    </div>
  );
};

export default ShapeContainer;
